import { styled } from '@mui/material';

export const ContentW = styled('div')`
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: center;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

export const FormW = styled('div')`
  width: 672px;
  position: relative;
  border-radius: 15px;

  @media (max-width: 1023px) {
    width: 100%;
    padding: 0px;
  }
`;

export const PageHeaderW = styled('div')`
  max-width: 671px;
  margin-bottom: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    max-width: unset;
    gap: 16px;
    padding-right: 8px;
  }
`;

export const CommentsCountW = styled('div')`
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.info.main};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.info.main}`};
  display: inline-block;
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const Count = styled('a')`
  white-space: nowrap;
`;

export const CommentsW = styled('div')`
  position: relative;
  width: 100%;
  max-width: 671px;
  margin-bottom: 64px;
`;
